import * as React from 'react';
import { RowButton, TDSnapshot, useTldrawApp } from 'sn-wb-tldraw';

import ProgressBar from '../ProgressBar';

const { useState, useEffect, useMemo } = React;

interface SpotlightProps {
  spotLightUser: string;
  users: any;
  user: any;
  updateUserFollowing: any;
  updateSpotlightUser: (arg: string) => void;
}

export const Spotlight = React.memo(function Spotlight({
  spotLightUser,
  users,
  user,
  updateUserFollowing,
  updateSpotlightUser,
}: SpotlightProps) {
  const [isSpotlight, setSpotlight] = useState<boolean>(false);
  const [isFollowing, setFollowing] = useState<boolean>(false);
  const [followers, setFollowers] = useState<number>(0);
  const spotlightUserObject = users?.find((u) => u?.id === +spotLightUser);
  const isSelfSpotlight = +spotLightUser === user?.id;

  useEffect(() => {
    const currentFollowers = users.filter((user) => {
      return user?.following == spotLightUser;
    });
    if (currentFollowers.length !== followers) {
      setFollowers(currentFollowers?.length);
    }
  }, [users, spotLightUser]);

  const handleCancel = () => {
    setSpotlight(false);
    updateSpotlightUser('');
  };

  useEffect(() => {
    if (spotLightUser) {
      setSpotlight(true);
      setFollowing(true);
    } else {
      updateUserFollowing('', user.point);
      setSpotlight(false);
      setFollowing(false);
    }
  }, [spotLightUser]);

  useEffect(() => {
    let timer: any;
    if (isSpotlight) {
      timer = setTimeout(() => {
        if (isFollowing && !isSelfSpotlight) {
          updateUserFollowing(spotlightUserObject?.id, spotlightUserObject?.point);
        }
        if (!isSelfSpotlight) setSpotlight(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isSpotlight, isFollowing]);

  const content = isSelfSpotlight ? (
    <ProgressBar>
      <div className="text-xs text-gray-60 mt-4">
        {followers
          ? followers + `${followers > 1 ? ' followers' : ' follower'}`
          : 'Waiting for followers'}{' '}
        |{' '}
        <span className="cursor-pointer" onClick={handleCancel}>
          Cancel
        </span>
      </div>
    </ProgressBar>
  ) : (
    <ProgressBar>
      <div className="text-xs text-gray-600 mt-4">
        Following {spotlightUserObject?.user?.name} |{' '}
        <span
          onClick={() => {
            setSpotlight(false);
            setFollowing(false);
          }}
        >
          Ignore
        </span>
      </div>
    </ProgressBar>
  );

  return (
    <>
      {isSpotlight && (
        <div
          className="absolute px-10 py-8 "
          style={{
            top: '32px',
            right: '50%',
            transform: 'translate(50%, 0%)',
            boxShadow: ' 0px 2px 12px rgba(19, 23, 32, 0.08)',
            borderRadius: '8px',
            background: '#fff',
            zIndex: 200,
          }}
        >
          <div
            id="TD-Spotlight"
            style={{
              pointerEvents: 'all',
              width: 'fit-content',
              minWidth: 0,
              gridRow: 1,
              flexGrow: 2,
              display: 'block',
              fontFamily: 'Graphik Web',
            }}
          >
            {content}
          </div>
        </div>
      )}
    </>
  );
});
